import { writable } from "svelte/store";
import { get } from "lodash";

export interface IndividualProductLastOrdered {
  case_quantity: number;
  container_label: string;
  container_type: string;
  product_id: number;
  submitted_at: string;
  unit_quantity: number;
  vintage_year: number | null;
}

type ProductsLastOrderedForDistributor = Record<string, IndividualProductLastOrdered>;
type ProductsLastOrdered = Record<string, ProductsLastOrderedForDistributor>;

export interface ProductsLastOrderedStore {
  productsLastOrdered: ProductsLastOrdered;
  getProductsLastOrdered(): ProductsLastOrdered;
  getProductsLastOrderedForDistributor(
    distributorId: number,
  ): ProductsLastOrderedForDistributor | null;
  getProductsLastOrderedForDistributorAndProduct(
    distributorId: number,
    productId: number,
  ): IndividualProductLastOrdered | null;
}

const buildGetterFunctions = (productsLastOrdered: ProductsLastOrdered) => {
  const getProductsLastOrdered = (): ProductsLastOrdered => productsLastOrdered;
  const getProductsLastOrderedForDistributor = (
    distributorId: number,
  ): ProductsLastOrderedForDistributor | null => productsLastOrdered[distributorId] || null;
  const getProductsLastOrderedForDistributorAndProduct = (
    distributorId: number,
    productId: number,
  ): IndividualProductLastOrdered | null =>
    get(productsLastOrdered, [distributorId, productId]) || null;

  return {
    getProductsLastOrdered,
    getProductsLastOrderedForDistributor,
    getProductsLastOrderedForDistributorAndProduct,
  };
};

const store = writable<ProductsLastOrderedStore>({
  productsLastOrdered: {},
  ...buildGetterFunctions({}),
});

const { set, subscribe } = store;

const setFromProductsLastOrdered = (productsLastOrdered: ProductsLastOrdered): void => {
  set({
    productsLastOrdered,
    ...buildGetterFunctions(productsLastOrdered),
  });
};

export default { subscribe, setFromProductsLastOrdered };
